"use strict";

class DeveloperPaymentPlansController {

    constructor($scope, $window, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSUserService, SSConfirmationService, SSAnalyticsService, Upload) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;

        self.PAYMENT_TRIGGER_TYPE_BOOKING = SHOWSUITE.PAYMENT_TRIGGER_TYPE_BOOKING;
        self.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED = SHOWSUITE.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED;

        self.DAYS_CALCULATION_TYPE_CALENDAR_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_CALENDAR_DAYS;
        self.DAYS_CALCULATION_TYPE_WORKING_DAYS = SHOWSUITE.DAYS_CALCULATION_TYPE_WORKING_DAYS;

        self.PAYMENT_TYPE_00_STANDARD = SHOWSUITE.PAYMENT_TYPE_00_STANDARD;
        self.PAYMENT_TYPE_01_BOOKING_FEE = SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;
        self.PAYMENT_TYPE_02_DEPOSIT = SHOWSUITE.PAYMENT_TYPE_02_DEPOSIT;
        self.PAYMENT_TYPE_03_FOUNDATION = SHOWSUITE.PAYMENT_TYPE_03_FOUNDATION;
        self.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK = SHOWSUITE.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK;
        self.PAYMENT_TYPE_05_BRICK_WALLS = SHOWSUITE.PAYMENT_TYPE_05_BRICK_WALLS;
        self.PAYMENT_TYPE_06_CEILING = SHOWSUITE.PAYMENT_TYPE_06_CEILING;
        self.PAYMENT_TYPE_07_INTERNAL_WORKS_1 = SHOWSUITE.PAYMENT_TYPE_07_INTERNAL_WORKS_1;
        self.PAYMENT_TYPE_08_INTERNAL_WORKS_2 = SHOWSUITE.PAYMENT_TYPE_08_INTERNAL_WORKS_2;
        self.PAYMENT_TYPE_09_EXTERNAL_WORKS = SHOWSUITE.PAYMENT_TYPE_09_EXTERNAL_WORKS;
        self.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION = SHOWSUITE.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION;
        self.PAYMENT_TYPE_11_CSC = SHOWSUITE.PAYMENT_TYPE_11_CSC;
        self.PAYMENT_TYPE_12_DLP = SHOWSUITE.PAYMENT_TYPE_12_DLP;
        self.PAYMENT_TYPE_13_COMPLETION = SHOWSUITE.PAYMENT_TYPE_13_COMPLETION;

        self.PAYMENT_TYPE_14_MAINTENANCE_FEE = SHOWSUITE.PAYMENT_TYPE_14_MAINTENANCE_FEE;
        self.PAYMENT_TYPE_15_SURVEY_FEE = SHOWSUITE.PAYMENT_TYPE_15_SURVEY_FEE;
        self.PAYMENT_TYPE_16_OTHER = SHOWSUITE.PAYMENT_TYPE_16_OTHER;
        self.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE = SHOWSUITE.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE;

        self.PAYMENT_TYPE_20_REFUND = SHOWSUITE.PAYMENT_TYPE_20_REFUND;


        self.data = SHOWSUITE.data;
        self.PAYMENT_TYPES = self.getAvailablePayments();
        self.filterd_payment_types = self.PAYMENT_TYPES;

        self.total_percentage = 0;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }

        self.const_dict_rule_names = SSConfigService.getPaymentPlanClauseRuleStartFromTypes();

        self.const_dict_rules = [];
    }

    init() {
        const self = this;

        self.user = self.SSUserService.getUser();
        if (!self.user) {
          self.SSUserService.showLoginModal();
        }

        // Trigger View Event for Payment Plans Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_PAYMENT_PLANS,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.offset = 0;
        self.limit = 10;
        self.selected_payment_plans_count = 0;

        self.pageChanged = function(newPage) {
            self.loadPaymentPlans(newPage);
        };

        self.setPageOptions();

        self.current = 1;
        self.jump_to_page = 1;

        self.paymentPlans = [];
        self.selectedPaymentPlan = [];
        self.PAYMENT_TYPES = self.getAvailablePayments();
        self.preparePaymentPlanTypes();
        self.prepareClauseTriggerTypes();
        self.prepareDayTypes();
        self.getPaymentPlans();
    }

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/payment-plans';
        let params = {
            include: "payment_plan_clauses"
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let responseData = response.data.payment_plans;

            if(responseData && responseData.length > 0){
                $.each(responseData, function(index, plan) {
                    plan.total_percentage = 0;
                    $.each(plan.payment_plan_clauses, function(index_clause, clause) {
                        if (!clause.amount_type || clause.amount_type == 10 && !clause.parent_payment_plan_clause_id) {
                            plan.total_percentage += clause.amount_percentage;
                        }
                    });
                });
                self.paymentPlans = responseData;
                self.payment_plans_master = angular.copy(self.paymentPlans);
                self.payment_plans_backup = angular.copy(self.paymentPlans);
                self.count = self.payment_plans_master.length;
                self.loadPaymentPlans(undefined, self.payment_plans_master);
            }
        });
    }

    // CLIENT SIDE PAGINATION
    loadPaymentPlans(page, payment_plans){
        const self = this;

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!payment_plans){
            payment_plans = self.payment_plans_backup;
        }

        self.payment_plans_master = payment_plans.slice(self.offset, self.limit + self.offset);
        self.count = payment_plans.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.payment_plans_master.length)){
            self.selected_payment_plans_count = self.limit;
        }
        else{
            self.selected_payment_plans_count = self.payment_plans_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    preparePaymentTypes(){
        const self = this;

        self.PAYMENT_TYPES = [
            {'id': self.PAYMENT_TYPE_01_BOOKING_FEE, 'name': 'Booking Fee'},
            {'id': self.PAYMENT_TYPE_02_DEPOSIT, 'name': 'S&P'},
            {'id': self.PAYMENT_TYPE_03_FOUNDATION, 'name': 'Foundation'},
            {'id': self.PAYMENT_TYPE_04_CONCRETE_FRAMEWORK, 'name': 'RC Frames'},
            {'id': self.PAYMENT_TYPE_05_BRICK_WALLS, 'name': 'Brick Walls'},
            {'id': self.PAYMENT_TYPE_06_CEILING, 'name': 'Ceiling/R'},
            {'id': self.PAYMENT_TYPE_07_INTERNAL_WORKS_1, 'name': 'Bidg M&E'},
            {'id': self.PAYMENT_TYPE_08_INTERNAL_WORKS_2, 'name': 'Electrical & Sanitary Equipment etc.'},
            {'id': self.PAYMENT_TYPE_09_EXTERNAL_WORKS, 'name': 'Ext Works'},
            {'id': self.PAYMENT_TYPE_10_NOTICE_OF_VACANT_POSSESSION, 'name': 'TOP'},
            {'id': self.PAYMENT_TYPE_11_CSC, 'name': 'CSC/DLP'},
            {'id': self.PAYMENT_TYPE_13_COMPLETION, 'name': 'S&P Completion'},
        ];
    }

    preparePaymentPlanTypes(){
        const self = this;

        self.PAYMENT_PLAN_TYPES = [
            {id: self.PAYMENT_PLAN_TYPE_NPS, name: 'NPS'},
            {id: self.PAYMENT_PLAN_TYPE_DPS, name: 'DPS'},
            {id: self.PAYMENT_PLAN_TYPE_PVT, name: 'PVT'},
        ];
    }

    prepareClauseTriggerTypes(){
        const self = this;

        self.CLAUSE_TRIGGER_TYPES = [
            {id: self.PAYMENT_TRIGGER_TYPE_BOOKING, name: 'BOOKING'},
            {id: self.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED, name: 'SPA RECEIVED'},
        ];
    }

    prepareDayTypes(){
        const self = this;

        self.DAY_TYPES = [
            {id: self.DAYS_CALCULATION_TYPE_WORKING_DAYS, name: 'Working Days'},
            {id: self.DAYS_CALCULATION_TYPE_CALENDAR_DAYS, name: 'Normal Days'}
        ];
    }

    setPaymentPlanViewMode(payment_plan){
        const self = this;

        self.paymentPlanParams = {};
        self.paymentPlanErrors = {};
        self.total_percentage = 0;

        self.clauses = [];
        self.force_delete = false;

        if(payment_plan){

            self.paymentPlanParams = angular.copy(payment_plan);
            self.selectedPaymentPlan = payment_plan;

            self.loadClauses(payment_plan.id);
            self.editPaymentPlan = false;
        }
        else{
            self.editPaymentPlan = true;
        }

        self.paymentPlanViewMode = true;
    }

    /**
     * Load a payment plan's clauses and render them in the order the server
     * returns them (WEB-4179): the server orders clauses by `order` and places
     * each child clause directly beneath its parent, so no client-side re-sort
     * is applied here — sorting locally would override that order.
     *
     * Also recomputes the plan's total percentage, so the running total is reset
     * on entry and this can safely be called again to refresh the list.
     */
    loadClauses(payment_plan_id){
        const self = this;

        if(!payment_plan_id){
            return;
        }

        let url = 'sec/developer/payment-plans/' + payment_plan_id + '/clauses';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.clauses = [];
            self.total_percentage = 0;

            if(response.data && response.data.payment_plan_clauses && response.data.payment_plan_clauses.length > 0){
                self.clauses = response.data.payment_plan_clauses;
                //Check is 100% for the payment plan
                $.each(self.clauses, function(index, clause) {
                    if (!clause.amount_type
                        || clause.amount_type == 10 && !clause.parent_payment_plan_clause_id
                    ) {
                        self.total_percentage += clause.amount_percentage;
                    }
                    if(clause.parent_payment_plan_clause_id){
                        clause.parent_payment_plan_clause_name = self.getParentPaymentPlanClauseName(clause);
                    }

                });
            }
        });
    }

    addClause(clause) {
        const self = this;

        self.clauseParams = {rules: []};
        self.clauseErrors = {};

        if (clause) {
            self.clauseParams = angular.copy(clause);
            if (typeof self.clauseParams.rules === 'string' || self.clauseParams.rules instanceof String) {
                self.clauseParams.rules = JSON.parse(self.clauseParams.rules);
            }
            self.selectedClause = clause;
            self.clauseParams.commission_due_indicator = clause.commission_due_indicator == 1;
            self.clauseParams.balance_payment_indicator = clause.balance_payment_indicator == 1;
            self.clauseParams.aborted_indicator = clause.aborted_indicator == 1;
        }

        if (!self.clauseParams.amount_type) {
            self.clauseParams.amount_type = 10;
        }
        self.clauseParams.amount_type = self.clauseParams.amount_type + '';
        self.filterd_payment_types = angular.copy(self.PAYMENT_TYPES);
        if(!clause){
            self.clauses.forEach((clause) =>{
                if(clause.payment_type !== self.PAYMENT_TYPE_12_DLP){
                    let findPaymentTypeIndex = self.filterd_payment_types.findIndex(x => x.id == clause.payment_type);
                    if(findPaymentTypeIndex > -1)
                        self.filterd_payment_types.splice(findPaymentTypeIndex, 1);
                }
            })
        }
        $('#addPaymentClauseModal').modal('show');
    }

    updatePaymentPlan(){
        const self = this;

        // Validate input fields
        if(!self.isValidPaymentPlanInput()){
            return;
        }

        self.paymentPlanErrors = {};

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + (self.paymentPlanParams.id ? 'update' : 'create') + ' this payment plan?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                self.roleErrors = {};

                let url = 'sec/developer/payment-plans';

                let params = self.paymentPlanParams;

                let responseHandler = function(response){
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Payment plan updated successfully.');
                    self.getPaymentPlans();
                    self.paymentPlanViewMode = false;
                };

                loading(true);
                if(self.paymentPlanParams.id){
                    url += '/' + self.paymentPlanParams.id;
                    self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
                }
                else{
                    self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
                }
            }
        );
    }

    updateClause(){
        const self = this;

        self.clauseErrors = {};
        if(self.clauseParams.payment_type === self.PAYMENT_TYPE_14_MAINTENANCE_FEE
            || self.clauseParams.payment_type === self.PAYMENT_TYPE_15_SURVEY_FEE
            || self.clauseParams.payment_type === self.PAYMENT_TYPE_16_OTHER
            || self.clauseParams.payment_type === self.PAYMENT_TYPE_20_REFUND
            || self.clauseParams.payment_type === self.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE ){
            self.clauseParams.amount_type = "10";
            self.clauseParams.amount_percentage = 0;
        }
        // Validate input fields
        if(!self.isValidClauseInput()){
            return;
        }

        let url = 'sec/developer/payment-plans/' + self.paymentPlanParams.id + '/clauses';
        self.clauseParams.commission_due_indicator = self.clauseParams.commission_due_indicator ? 1 : 0;
        self.clauseParams.balance_payment_indicator = self.clauseParams.balance_payment_indicator ? 1 : 0;
        self.clauseParams.aborted_indicator = self.clauseParams.aborted_indicator ? 1 : 0;

        let params = self.clauseParams;


        let responseHandler = function(response){
            loading(false);
            if (response instanceof Error) {
                if (response.code === 400) {
                    self.clauseErrors.code = response.message;
                } else {
                    self.SSAlertService.parseAndDisplayError(response);
                    if(typeof response.data.code !=='undefined' && typeof response.data.code[0] !=='undefined'){
                        self.clauseErrors.code =  response.data.code[0];
                    }
                    if(typeof response.data.payment_type !=='undefined' && typeof response.data.payment_type[0] !=='undefined'){
                        self.clauseErrors.payment_type =  response.data.payment_type[0];
                        console.log(self.clauseErrors.payment_type);
                    }
                    // $('#addPaymentClauseModal').modal('hide');
                }
                return;
            }

            $('#addPaymentClauseModal').modal('hide');

            self.SSAlertService.success('Success!', 'Clause ' + (self.clauseParams.id ? 'updated' : 'added') + ' successfully.');
            
            // WEB-4179: reload the list rather than splicing the saved clause into
            // the local array. The server decides the display order (by `order`,
            // children under their parent), so a clause whose sequence or parent
            // just changed has to be re-placed by the server — the previous
            // remove-push-and-sort-by-id could not do that.
            self.loadClauses(self.paymentPlanParams.id);
        };

        loading(true);
        if(self.clauseParams.id){
            url += '/' + self.clauseParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        }
        else{
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deleteClause(delete_clause_id){
        const self = this;

        self.delete_clause_id = delete_clause_id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to delete this clause?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deleteClause();
            }
        );
    }

    _deleteClause(){
        const self = this;

        let url = 'sec/developer/payment-plans/';
        url += self.paymentPlanParams.id + '/clauses/' + self.delete_clause_id +'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(response.code == 404 && response.message){
                    self.SSAlertService.danger("Error!", response.message);
                }
                else{
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            self.SSAlertService.success('Success!', 'Clause deleted successfully.');
            // WEB-4179: reload rather than dropping the row locally — deleting a
            // parent clause re-roots its children, which changes where the server
            // places them, and the reload also refreshes the total percentage.
            self.loadClauses(self.paymentPlanParams.id);
        });
    }

    deletePaymentPlan(payment_plan_id){
        const self = this;

        self.delete_payment_plan_id = payment_plan_id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            self.force_delete ? 'The payment plan is currently applied to a project/sale. Are you sure you would like to proceed with this action?\nNote: Please note that by proceeding with this action, projects and sales which are applied with this payment plans will be removed.' : 'Are you sure you would like to delete this payment plan?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deletePaymentPlan();
            }
        );
    }

    _deletePaymentPlan(){
        const self = this;

        let url = 'sec/developer/payment-plans/';
        url += self.delete_payment_plan_id +'/delete';
        let param = {};

        if (self.force_delete) {
            param = {
                force: true
            }
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(response.code == 404 && response.message){
                    self.SSAlertService.danger("Error!", response.message);
                } else if (response.code == 409) {
                    self.SSAlertService.danger("Error!", response.data.payment_plan_id[0]);
                } else{
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            self.SSAlertService.success('Success!', 'Payment plan deleted successfully.');
            
            self.getPaymentPlans();
            self.paymentPlanViewMode = false;
        });
    }

    getPaymentTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        try{
            let payment_type = self.PAYMENT_TYPES.find(x => x.id == type);
            if(payment_type){
                name = payment_type.name;
            }
        }
        catch(ex){
            console.log(ex);
        }

        return name;
    }

    getDayTypeName(type) {
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        return self.DAY_TYPES.find(x => x.id == type).name;
    }

    getPlanTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        return self.PAYMENT_PLAN_TYPES.find(x => x.id == type).name;
    }

    getTriggerTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        return self.CLAUSE_TRIGGER_TYPES.find(x => x.id == type).name;
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    isValidPaymentPlanInput() {
        const self = this;

        let isValid = true;

        self.paymentPlanErrors = {};

        if (!self.paymentPlanParams.name) {
            self.paymentPlanErrors.name = 'Name is required';
            isValid = false;
        } else if (self.paymentPlanParams.name.length < 2) {
            self.paymentPlanErrors.name = 'The name must be at least 2 characters';
            isValid = false;
        } else if (self.paymentPlanParams.name.length > 128) {
            self.paymentPlanErrors.name = 'The name must be at most 128 characters';
            isValid = false;
        }
        if (!self.paymentPlanParams.code) {
            self.paymentPlanErrors.code = 'Code is required';
            isValid = false;
        } else if (self.paymentPlanParams.code.length < 2) {
            self.paymentPlanErrors.code = 'The code must be at least 2 characters';
            isValid = false;
        } else if (self.paymentPlanParams.code.length > 14) {
            self.paymentPlanErrors.code = 'The code must be at most 14 characters';
            isValid = false;
        }
        if (!self.paymentPlanParams.type) {
            self.paymentPlanErrors.type = 'Payment plan type is required';
            isValid = false;
        }

        return isValid;
    }

    isValidClauseInput() {
        const self = this;

        let isValid = true;

        self.clauseErrors = {};

        if (!self.clauseParams.name) {
            self.clauseErrors.name = 'Name is required';
            isValid = false;
        } else if (self.clauseParams.name.length < 3) {
            self.clauseErrors.name = 'The name must be at least 3 characters';
            isValid = false;
        } else if (self.clauseParams.name.length > 128) {
            self.clauseErrors.name = 'The name must be at most 128 characters';
            isValid = false;
        }
        if (!self.clauseParams.code) {
            self.clauseErrors.code = 'Code is required';
            isValid = false;
        } else if (self.clauseParams.code.length < 2) {
            self.clauseErrors.code = 'The code must be at least 2 characters';
            isValid = false;
        } else if (self.clauseParams.code.length > 14) {
            self.clauseErrors.code = 'The code must be at most 14 characters';
            isValid = false;
        }
        if (!self.clauseParams.amount_percentage &&  self.clauseParams.payment_type !== self.PAYMENT_TYPE_14_MAINTENANCE_FEE
            && self.clauseParams.payment_type !== self.PAYMENT_TYPE_15_SURVEY_FEE
            && self.clauseParams.payment_type !== self.PAYMENT_TYPE_16_OTHER
            && self.clauseParams.payment_type !== self.PAYMENT_TYPE_20_REFUND
            && self.clauseParams.payment_type !== self.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE) {
            self.clauseErrors.amount_percentage = 'Payment amount is required';
            isValid = false;
        }

        if (!self.clauseParams.payment_type) {
            self.clauseErrors.payment_type = 'Payment type is required';
            isValid = false;
        }

        if(self.clauseParams.rules.length > 0){
            self.clauseParams.rules.forEach(element => {
                if(!element.billing_days || element.billing_days <= 0 || element.start_from == 0) {
                    isValid = false;
                }
            });
        }
        
        // if (!self.clauseParams.interest_rate) {
        //     self.clauseErrors.interest_rate = 'Interest rate is required';
        //     isValid = false;
        // }
        // if (!self.clauseParams.trigger_type) {
        //     self.clauseErrors.trigger_type = 'Trigger type is required';
        //     isValid = false;
        // }

        // if (!self.clauseParams.grace_period) {
        //     self.clauseErrors.grace_period = 'Grace period field is required';
        //     isValid = false;
        // }
        // if (!self.clauseParams.description) {
        //     self.clauseErrors.description = 'Description is required';
        //     isValid = false;
        // }

        // if (self.clauseParams.description && self.clauseParams.description.length > 255) {
        //     self.clauseErrors.description = 'Description is maximum 255 characters';
        //     isValid = false;
        // }

        return isValid;
    }

    addNewRule() {
        const self = this;
        self.clauseParams.rules.push({'start_from': 0, 'billing_days': 0});
    }

    deleteRule(rule) {
        const self = this;
        let values = _.remove(self.clauseParams.rules, function (n) {
            return n != rule;
        });
        self.clauseParams.rules = values;
    }

    getAvailablePayments() {
        const self = this;

        /** WEB-3013 [WEB-3010] : AllGreen : Post Data to SAP single or multiple data selection and post
         * Need to allow Refund type **/
        return self.data.config.payment_types;
        // return self.data.config.payment_types.filter(x => x.id != self.PAYMENT_TYPE_20_REFUND);
    }

    prepareEditPaymentPlan() {
        const self = this;

        self.editPaymentPlan = true;
        self.temp_payment_plan = angular.copy(self.paymentPlanParams);
    }

    cancelEditPaymentPlan() {
        const self = this;

        self.editPaymentPlan = false;
        self.paymentPlanParams = angular.copy(self.temp_payment_plan);
    }

    getPaymentPlanClauseAmountDisplayValue(paymentPlanClause) {
        if (paymentPlanClause) {
            if (!paymentPlanClause.amount_type
                || paymentPlanClause.amount_type == 10
            ) {
                return paymentPlanClause.amount_percentage + '%';
            } else if (paymentPlanClause.amount_type == 20) {
                return '$' + paymentPlanClause.amount_percentage;
            }
        }
        return '--';
    }

    getParentPaymentPlanClauseName(paymentPlanClause) {
        const self = this;
        if (paymentPlanClause) {
            return self.clauses.find(x => x.id == paymentPlanClause.parent_payment_plan_clause_id).name
        }
        return '--';
    }

    getClauseNameById(clause_id ,clauses){
        if(!clause_id){
            return;
        }
        let clause = null;
        try{
            if(clauses){
                clause = clauses.find(x => x.id == clause_id);
            }
        }
        catch(ex){
        }
        if(clause){
            return clause.name;
        }
        return "";
    }

    parentPlanSelected(parentId){
        const self = this;
        self.clauseParams.rules = [];
    }

    paymentTypeSelected(paymentId) {
        const self = this;
        if (paymentId === self.PAYMENT_TYPE_14_MAINTENANCE_FEE
            || paymentId === self.PAYMENT_TYPE_15_SURVEY_FEE
            || paymentId === self.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE) {
            self.clauseParams.amount_type = "10";
            self.clauseParams.amount_percentage = 0;
        }
    }
    exportPaymentPlans(){
        const self = this;
        let url = 'sec/developer/payment-plans/payment-plans-export';
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
        self.SSAlertService.success('Payment plans exported successfully.');
    }


    importPaymentPlans(file) {
        const self = this;
        if (!file) {
            return;
        }
        let url = self.SSHttpService.getApiURL('sec/developer/import/payment-plans');


        loading(true);


        self.Upload.upload({
            url: url,
            method: 'POST',
            data: {
                import_file: file,
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Payment plans imported successfully");
            self.getPaymentPlans();

        }, function (response) {
            loading(false);

            self.SSAlertService.parseAndDisplayError(response);
        });
    }

    getUniqueValues(arr, key) {
        if (!Array.isArray(arr) || arr.length === 0) {
            return [];
        }

        let unique_values = [];
        arr.forEach(o => {
            if (unique_values.indexOf(o[key]) === -1){
                unique_values.push(o[key]);
            }
        })
        return unique_values;
    }

    openPostingInfoPopup(clause) {
        const self = this;

        if (!clause || !clause.id || !clause.payment_plan_id) { return false; }
        let url = "sec/developer/payment-plans/"+ clause.payment_plan_id +"/clauses/"+ clause.id +"/get-ledger-entries";
        self.selectedPostingClause = clause;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data){
                self.postingInfoGroupList = [];
                if (response.data.payment_plan_ledger_entries && response.data.payment_plan_ledger_entries.length){
                    let payment_plan_ledger = _.sortBy(response.data.payment_plan_ledger_entries, "group_id");
                    let group_ids = self.getUniqueValues(payment_plan_ledger, "group_id");

                    group_ids.forEach(group_id => {
                        let postingInfoList = payment_plan_ledger.filter(e => e.group_id === group_id);

                        postingInfoList = postingInfoList.map(e => {
                            return {
                                code: e.code,
                                name: e.name,
                                type: e.type,
                                transaction_type: e.transaction_type
                            }
                        })

                        self.postingInfoGroupList.push(postingInfoList)
                    })
                }

                self.postingInfoErr = "";
                $('#addPostingInfoModal').modal('show');
            }
        });
    }

    addPostingGroup(){
        const self = this;

        self.postingInfoErr = "";
        self.postingInfoGroupList = self.postingInfoGroupList || [];
        if (self.postingInfoGroupList.length < 1){ // If first group set default transaction_type billing
            self.postingInfoGroupList.push([{
                transaction_type: 'billing',
            }]);
        } else {
            self.postingInfoGroupList.push([{ // If first group set default transaction_type receipt
                transaction_type: 'receipt',
            }]);
        }
    }

    addPostingInfo(postingInfoGroup) {
        const self = this;

        self.postingInfoErr = "";
        postingInfoGroup.push({});
    }

    deletePostingInfo(postingInfoGroup, entryIndex, groupIndex) {
        const self = this;

        self.postingInfoErr = "";
        if (!postingInfoGroup || !postingInfoGroup.length) { return false;}

        postingInfoGroup.splice(entryIndex,1);
        if (!postingInfoGroup.length) { // If Group is empty then remove
            self.postingInfoGroupList.splice(groupIndex, 1);
        }
    }

    isValidPostingInfo(postingInfoGroupList) {
        const self = this;

        let isValid = true;
        self.postingInfoErr = "";
        if (!postingInfoGroupList || !postingInfoGroupList.length){
            self.postingInfoErr = "Please click Add Group to add new group of posting info.";
            return false;
        }

        postingInfoGroupList.forEach(postingInfoGroup => {
            if (!postingInfoGroup || !postingInfoGroup.length){
                self.postingInfoErr = "Please add some posting info data to continue.";
                return false;
            }

            postingInfoGroup.forEach((postingInfo, index) => {
                postingInfo.codeError = null;
                postingInfo.typeError = null;
                postingInfo.transaction_typeError = null;

                if (index === 0){ // Check transaction_type set against first entry of each group
                    if (!postingInfo.transaction_type){
                        postingInfo.transaction_typeError = "Transaction type is required";
                        isValid = false;
                    }
                }

                if(!postingInfo.code) {
                    postingInfo.codeError = "Code is required";
                    isValid = false;
                }
                if(!postingInfo.type) {
                    postingInfo.typeError = "Type is required";
                    isValid = false;
                }
            })
        })

        return isValid;
    }

    savePostingInfo() {
        const self = this;

        if (!self.selectedPostingClause || !self.selectedPostingClause.payment_plan_id) { return false; }

        if (self.isValidPostingInfo(self.postingInfoGroupList)) {
            let url = "sec/developer/payment-plans/"+ self.selectedPostingClause.payment_plan_id +"/clauses/"+ self.selectedPostingClause.id +"/update-ledger-entries";


            let postingsInfoList = [];
            self.postingInfoGroupList.forEach( (postingInfoGroup, groupIndex) => {
                let group_transaction_type = postingInfoGroup[0].transaction_type; // Map transaction_type from first entry of each group to remaining entries
                postingInfoGroup.forEach( postingInfo => {
                    postingsInfoList.push({
                        code: postingInfo.code,
                        group_id: groupIndex,
                        name: postingInfo.name,
                        type: postingInfo.type, // CR/DR
                        transaction_type: group_transaction_type // billing/Receipt
                    })
                })
            })
            let params = {
                data: postingsInfoList
            };

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return false;
                }

                $('#addPostingInfoModal').modal('hide');
                self.SSAlertService.success("Success!", "Posting Info updated successfully.");
            })
        }
    }

}

DeveloperPaymentPlansController.$inject = ['$scope', '$window', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSUserService','SSConfirmationService', 'SSAnalyticsService', 'Upload'];
app.controller('DeveloperPaymentPlansController', DeveloperPaymentPlansController);

